import { PATH } from '@/enum'

import {
  Enterprise,
  CloudLayout,
  // SdLayout,
  Home,
  ImageShare,
  IpvmDetail,
  IpvmLayout,
  CenterLayout,
  Layout,
  BillServerDetail,
  BillStorageDetail,
  BillModelDetail,
  Personal,
  Purchase,
  Rdp,
  RdpS,
  ThirdLogin,
  Recharge,
  Finance,
  CreateData,
  DatasetDetails,
  UploadImage,
  ComputeDetail,
  GenericLayout,
  Workflow,
  ModelLayout,
} from '../components'
import ModelBlock from '@/views/model/block/index.vue'
import { menus, center, generic, clouds, ai, models } from './menu'
import PurLayout from '@/views/purchase/layout/Layout.vue'
export const sdRoute = [
  {
    path: PATH.SD,
    // component: Layout,
    redirect: PATH.TRAIN,
    children: [
      {
        path: PATH.TRAIN,
        // component: SdLayout,
        children: [...ai],
      },
      // 数据集 创建与详情
      {
        path: PATH.CREATE_DATA_SET,
        component: CreateData,
        name: PATH.CREATE_DATA_SET,
        title: '创建数据集',
        meta: {
          requireAuth: true,
        },
      },
      {
        path: PATH.DETAIL_DATA_SET,
        component: DatasetDetails,
        name: PATH.DETAIL_DATA_SET,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: PATH.UPLOAD_IMAGE_SET,
        component: UploadImage,
        title: '上传图片',
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
]
export const routes = [
  {
    path: PATH.HOME,
    redirect: PATH.GPU,
    name: 'home',
  },
  {
    path: PATH.LOGIN,
    component: Home,
    name: 'login',
  },
  {
    path: PATH.REGISTER,
    component: Home,
    name: 'register',
  },

  {
    path: PATH.ENTERPRISE,
    component: Enterprise,
    name: 'enterprise',
  },
  {
    path: PATH.WORKFLOW,
    component: Workflow,
    name: PATH.WORKFLOW,
    title: '工作流',
    meta: {
      requireAuth: true,
    },
  },
  {
    path: `${PATH.RDP}/:id`,
    component: Rdp,
    meta: {
      requireAuth: true,
    },
    name: PATH.RDP,
  },
  {
    path: `${PATH.FINANCE}`,
    component: Finance,
    meta: {
      requireAuth: true,
    },
    name: 'finance',
  },

  {
    path: `/free/:id`,
    component: RdpS,
    name: 'rdps',
    meta: {
      requireAuth: true,
    },
  },
  {
    path: PATH.THIRDLOGIN,
    component: ThirdLogin,
    name: 'thirdlogin',
  },
  {
    path: PATH.STATIC,
    component: Layout,
    children: [
      {
        path: PATH.CLOUD,
        component: CloudLayout,
        redirect: PATH.GPU,
        children: [...clouds],
      },
      {
        path: PATH.PURCHASE,
        component: PurLayout,
        children: [
          {
            path: PATH.PURCHASE,
            component: Purchase,
            name: PATH.PURCHASE,
          },
        ],
        // meta: {
        //   requireAuth: true,
        // },
      },
      {
        path: `${PATH.IMAGESHARE}/:id`,
        component: ImageShare,
        name: PATH.IMAGESHARE,
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
  ...sdRoute,
  {
    path: PATH.COMPUTE,
    component: Layout,
    children: [
      {
        path: PATH.COMPUTE_DETAIL,
        component: ComputeDetail,
        name: PATH.COMPUTE_DETAIL,
        title: '算力明细',
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
  {
    path: PATH.CONSOLE,
    component: Layout,
    children: [
      {
        path: PATH.PERSONAL,
        component: Personal,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: PATH.ENTERPRISE,
        component: Enterprise,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: PATH.IPVMDETAIL + '/:type/:id',
        component: IpvmDetail,
        name: PATH.IPVMDETAIL,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: `${PATH.COST_BILL_SERVER_DETAIL}/:id`,
        component: BillServerDetail,
        name: PATH.COST_BILL_SERVER_DETAIL,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: PATH.COST_BILL_STORAGE_DETAIL,
        component: BillStorageDetail,
        name: PATH.COST_BILL_STORAGE_DETAIL,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: `${PATH.COST_BILL_MODEL_DETAIL}/:date`,
        component: BillModelDetail,
        name: PATH.COST_BILL_MODEL_DETAIL,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: PATH.BASE,
        component: IpvmLayout,
        redirect: PATH.GPU_GENERIC,
        children: [...menus],
      },
      {
        path: PATH.GENERIC,
        component: GenericLayout,
        redirect: PATH.APPARATUS_GENERIC,
        children: [...generic],
      },
      {
        path: PATH.CENTER,
        component: CenterLayout,
        redirect: PATH.COST,
        children: [...center],
      },
      {
        path: PATH.RECHARGE,
        component: Recharge,
        name: PATH.RECHARGE,
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
  {
    path: PATH.MODEL,
    component: Layout,
    children: [
      {
        path: '/',
        component: ModelLayout,
        children: [...models],
      },
    ],
  },
  {
    path: '/status/block',
    component: ModelBlock,
    name: 'model-block',
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/',
  },
]
